const Education = () => {
    return (
        <>
            <h2 data-transl="" class="mb-5">Education</h2>
            <div className="flex flex-row mb-6 justify-between 926:flex-col 926:gap-2.5">
                <div className="w-48 926:mb-2.5">Sep 2016 - Jul 2021</div>
                <div className="w-full">
                    <div className="mb-2.5 font-bold">Belarusian National Technical University</div>
                    <div className="text-justify leading-relaxed max-w-5xl md:text-sm font-bold">Bachelor’s degree in engineering</div>
                    <div className="text-justify leading-relaxed max-w-5xl md:text-sm">With a background in electronic engineering, I have acquired unique skills in analysis, solving complex problems, and meticulous work with technical documentation during my 5 years of university education. These skills have proven to be incredibly valuable in my journey into web development. My foundational approach to problem-solving, systematic thinking, and commitment to quality has become an integral part of my professional growth in web development. Combined with the technological expertise gained in the study of web technologies, it forms a unique set of skills that I successfully apply in creating modern and efficient web applications.</div>
                </div>
            </div>
        </>
    )
}

export default Education